<template>
  <div class="home">
    <div v-show="isShowNewsUi" class="home-new">
      <NewsItem :data="newsData1[0]" @return="handleReturnFromNews" />
    </div>
    <div v-show="!isShowNewsUi">
      <div class="home-top">
        <div class="top-left">
          <h3>公司简介</h3>
          <p>
            {{ gsjjText }}
          </p>
          <span style="cursor: pointer; color: #409eff; font-size: 12px" @click="handleMoreClickXQ"
            >详情>></span
          >
        </div>
        <div class="top-right">
          <h3>新闻动态</h3>
          <div class="new-lists">
            <ListComponent :items="listData" @item-click="handleItemClick" />
          </div>
        </div>
      </div>
      <div class="home-bottom">
        <div class="bottom-title">
          <h3>项目案例</h3>
          <span style="cursor: pointer" @click="handleMoreClick">更多</span>
        </div>
        <div style="margin-top: 10px">
          <el-carousel :interval="4000" type="card" height="200px">
            <el-carousel-item v-for="item in imageList" :key="item.id">
              <img :src="item.src" style="width: 100%; height: 100%; object-fit: contain" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>

    <SiteFooter />
  </div>
</template>

<script>
  import NewsItem from '../components/NewsItem.vue'
  import SiteFooter from '../components/SiteFooter.vue'
  import ListComponent from '../homePages/ListComponent.vue'
  export default {
    components: { ListComponent, SiteFooter, NewsItem },
    data() {
      return {
        listData: [
          {
            id: 1,
            text: '公司获批黄河水利职业技术大学“双创”基地',
            time: '2025-12-31 15:02:00'
          },
          {
            id: 2,
            text: '公司参与的团体标准获河南省水利学会批准发布',
            time: '2025-12-25 14:33:07'
          },
          {
            id: 3,
            text: '公司顺利通过高新技术企业复审',
            time: '2025-11-25 16:07:07'
          },
          {
            id: 4,
            text: '公司获批河南省工程建设省级工法',
            time: '2025-10-30 16:03:08'
          },
          {
            id: 5,
            text: '公司获批河南省建筑业协会会员单位',
            time: '2025-08-30 09:33:27'
          },
          {
            id: 6,
            text: '公司助力白龟山水库新建泄洪闸温控施工',
            time: '2025-05-17 11:30:25'
          },

          {
            id: 7,
            text: '公司获批河南省水利学会会员单位',
            time: '2024-08-19 15:59:00'
          },
          {
            id: 8,
            text: '公司荣获郑州大学科技园年度考核优秀企业',
            time: '2024-06-21 15:18:00'
          },
          {
            id: 9,
            text: '公司获批多个省市研发中心、实验室和科普示范基地',
            time: '2024-06-14 09:36:00'
          },
          {
            id: 10,
            text: '公司获批郑州市工程技术中心',
            time: '2023-07-07 17:46:00'
          },
          {
            id: 11,
            text: '公司获批河南省工程技术研究中心',
            time: '2023-07-06 09:30:00'
          },
          {
            id: 12,
            text: '公司两项成果获河南省水利科技进步奖',
            time: '2023-07-06 09:29:00'
          },
          {
            id: 13,
            text: '公司顺利通过国家高新技术企业认定',
            time: '2022-12-19 16:30:00'
          },
          {
            id: 14,
            text: '公司参与项目顺利通过省水利厅结项验收',
            time: '2022-08-01 15:12:00'
          },
          {
            id: 15,
            text: '公司参与项目顺利通过省水利厅结项验收',
            time: '2021-11-09 17:03:00'
          },
          {
            id: 16,
            text: '公司多项专利获国家授权',
            time: '2021-04-23 16:19:00'
          },
          {
            id: 17,
            text: '公司应邀参加“厚山论道”活动',
            time: '2020-11-20 16:21:00'
          },
          {
            id: 18,
            text: '郑大水利科技赴信阳开展电站服务工作',
            time: '2020-11-20 16:12:00'
          },
          {
            id: 19,
            text: '郑大水利科技赴洛阳考察学习',
            time: '2020-07-09 17:05:00'
          },
          {
            id: 20,
            text: '郑大水利科技参加园区年度工作会议',
            time: '2020-07-01 18:04:00'
          },
          {
            id: 21,
            text: '郑大水利科技通过国家科技型中小企业备案',
            time: '2020-07-01 15:42:00'
          },
          {
            id: 22,
            text: '郑大水利科技通过郑州市科技型企业备案',
            time: '2020-07-01 14:31:00'
          },
          {
            id: 23,
            text: '郑大水利科技多项科技成果获国家授权登记',
            time: '2020-06-10 20:40:00'
          }
        ],

        newsData: [
          {
            id: 1,
            title: '公司获批黄河水利职业技术大学“双创”基地',
            time: '2025-12-31 15:02:00',
            text: [
              '近日，公司成功获批黄河水利职业技术大学创新创业实践教学基地。',
              '黄河水利职业技术大学是国内知名的水利专业职业大学，公司与黄河水利职业技术大学在研发创新、知识产权、学生培养、创新创业等方面展开深入合作，下一步公司将充分发挥基地建设作用，推动与黄河水利职业技术大学的全方位合作。'
            ],
            images: require('@/assets/images/news/双创基地.jpg')
          },
          {
            id: 2,
            title: '公司参与的团体标准获河南省水利学会批准发布',
            time: '2025-12-25 14:33:07',
            text: [
              '12月24日，公司作为主要参与人完成的河南省水利学会团体标准《河南省小水电站生态流量泄放与保障技术规程》（T/HNSL0001-2025）获批准发布。',
              '该标准对生态流量核定、泄放设施建设与改造、泄放过程监控、保障措施及监督管理等方面均作出了明确规定和技术要求，对于规划河南省小水电站的生态流量泄放保障具有重要意义。'
            ],
            images: require('@/assets/images/news/团标批准.jpg')
          },
          {
            id: 3,
            title: '公司顺利通过高新技术企业复审',
            time: '2025-11-25 16:07:07',
            text: [
              '近日，河南省公布了2025年认定报备的第一批高新技术企业，公司名列其中，顺利通过复审。',
              '高新技术企业的复审通过是对公司技术研发和成果转化的认可，下一步公司将继续谋定研发方向，加大研发投入，布局知识产权，推动技术成果向生产实际转化。'
            ],
            images: null
            // images: require("@/assets/images/news/微信图片_20240819155845.jpg"),
          },
          {
            id: 4,
            title: '公司获批河南省工程建设省级工法',
            time: '2025-10-30 16:03:08',
            text: [
              '近日，河南省建筑业协会公布了2025年度第二批河南省省级工法，公司参与完成的《带齿槽闸底板冷却通水布置及控制施工工法》成功获批。',
              '该工法针对带齿槽的闸底板温控施工进行技术创新，创造性提出了冷却通水布置及控制的相关工艺和工法流程，该技术在白龟山水库除险加固工程新建泄洪闸的闸底板施工中得到成功应用，有效保障了混凝土的温控施工质量。'
            ],
            images: require('@/assets/images/news/工法获批图片.jpg')
          },
          {
            id: 5,
            title: '公司获批河南省建筑业协会会员单位',
            time: '2025-08-30 09:33:27',
            text: [
              '近日，公司成功获批河南省建筑业协会会员单位。',
              '河南省建筑业协会是由全省各市、各部门从事土木工程、建筑工程、设备安装工程、建筑科研和教育等企事业单位自愿结成的非营利性的区域性行业社团组织，在河南省建筑行业有着广泛的影响力。',
              '下一步公司将以此为契机，加大科研投入，服务建筑业发展。'
            ],
            images: null
          },
          {
            id: 6,
            title: '公司助力白龟山水库新建泄洪闸温控施工',
            time: '2025-05-17 11:30:25',
            text: [
              '近日，由河南省水利第二工程局集团有限公司承建的白龟山水库除险加固工程新建泄洪闸闸墩施工圆满收官，刷新了河南省水利施工速度。',
              '我公司作为技术支持，全程参与了白龟山水库新建泄洪闸的温控施工全过程工作，通过应用公司自主研发的远程测温、智能通水调控系统，有效保证了泄洪闸的施工质量，施工过程中温度均控制在规范要求范围内，未出现温度裂缝，有效保障了泄洪闸的温控施工质量。'
            ],
            images: require('@/assets/images/news/白龟山泄洪闸.jpg')
          },

          {
            id: 7,
            title: '公司获批河南省水利学会会员单位',
            time: '2024-08-19 15:59:00',
            text: [
              '近日，公司获批河南省水利学会会员单位（2024年）。河南省水利学会是河南省水利行业学术性和非营利性社会团体，学会挂靠河南省水利厅，并接受河南省科协的业务指导和监督管理。',
              '此次会员单位的获批，将进一步促进公司水利相关业务的开展，为后续工作的进行提供了良好基础。'
            ],
            images: require('@/assets/images/news/微信图片_20240819155845.jpg')
          },
          {
            id: 8,
            title: '公司荣获郑州大学科技园年度考核优秀企业',
            time: '2024-06-21 15:18:00',
            text: [
              '近日，郑州大学科技园举办2023年度在孵企业表彰大会，园区在孵企业代表、科技园公司全体员工参加会议。会议对园区年度优秀企业进行集中表彰，公司荣获2023年年度考核优秀企业，并获得知识产权奖励。'
            ],
            images: require('@/assets/images/news/微信截图_20240621151726.png')
          },
          {
            id: 9,
            title: '公司获批多个省市研发中心、实验室和科普示范基地',
            time: '2024-06-14 09:36:00',
            text: [
              '近日，公司与河南水利与环境职业学院等单位联合申报的河南省水电系统装备及智能化研发中心、水利工程智能设备工匠实验室、郑州市绿色能源装备与智慧系统科普示范基地等陆续获批。'
            ],
            images: require('@/assets/images/news/微信截图_20240614093611.png')
          },
          {
            id: 10,
            title: '公司获批郑州市工程技术中心',
            time: '2023-07-07 17:46:00',
            text: [
              '近日，郑州市发展改革委员会公布了2022年新建郑州市工程研究中心名单，公司顺利获批郑州市工程技术中心。',
              '郑州市工程技术研究中心是依托市内某一行业或领域内具有较高水平的企业组建的研发中心，其任务是针对行业发展中的重大关键、共性技术问题，开展研发和成果的工程化、产业化，推动相关行业、领域的技术进步和产业发展。',
              '此次获批的“郑州市水利水电智能装备工程研究中心”为公司联合河南省水利与环境职业学院共同申报，旨在解决水利水电智能装备系统的研发关键技术问题，推动水利水电装备智能化升级发展。'
            ],
            images: ''
          },
          {
            id: 11,
            title: '公司获批河南省工程技术研究中心',
            time: '2023-07-06 09:30:00',
            text: [
              '近日，河南省科技厅公布了2022年度河南省工程技术研究中心名单，公司顺利获批河南省工程技术研究中心。',
              '此次获批的“河南省水电装备与智慧系统工程技术研究中心”是公司联合河南省水利与环境职业学院创建的具有国内领先技术的研究机构，其中河南水利与环境职业学院为牵头单位，公司为主要联合单位，该研究中心将以水电装备与智慧系统为主要研究载体，围绕水电智慧运行调度及智能装备研发等展开技术攻关，并形成水电智能运行的整套解决方案和技术体系，推动我省水电行业的高效绿色发展。'
            ],
            images: ''
          },
          {
            id: 12,
            title: '公司两项成果获河南省水利科技进步奖',
            time: '2023-07-06 09:29:00',
            text: [
              '近日，2022年度河南省水利科学技术奖获奖成果揭晓，公司参与的两项科研成果分别荣获河南省水利科技进步奖一等奖和二等奖。',
              '河南省水利科技进步奖是河南省水利行业的重要奖项，旨在表彰在水利科研方面做出突出贡献的团体个人，此次奖励获得是对公司科研工作的高度认可，下一步公司将以此为契机，加快科研工作投入，积极推动产学研结合，实现科研成果的高效转化。'
            ],
            images: ''
          },
          {
            id: 13,
            title: '公司顺利通过国家高新技术企业认定',
            time: '2022-12-19 16:30:00',
            text: [
              '公司近日顺利通过国家高新技术企业认定，这次成功入选国家高新技术企业，充分说明了国家相关部门对公司多年来工作的肯定。',
              '下一步公司将以此次认定为契机，继续加大投入，促进水利领域智能调度管理技术等核心业务的研发与推广。'
            ],
            images: ''
          },
          {
            id: 14,
            title: '公司参与项目顺利通过省水利厅结项验收',
            time: '2022-08-01 15:12:00',
            text: [
              '7月29日，公司参与的河南省水利科技攻关项目“基于水质功能的水库电站智慧调度管理研究与应用”顺利通过河南省水利厅结项验收。',
              '该项目以信阳市南湾水库管理局、河南郑大水利科技有限公司为主要完成单位，构建了浉河水质分析预测的大数据模型，分析了特殊水质功能下的水库调度响应方案；基于河流水质，分别构建了水库调度和电站优化决策模型，融合融合平台系统与数学模型，开发形成了南湾水库的智能调度管理平台。',
              '上述研究成果在河南省多个项目中得到成功应用，取得了较好的经济效益和社会效益。',
              '专家组在听取项目汇报后，审查了项目相关资料，在详细质询的基础上，认为项目研究达到了预期目标，研究成果具有国内领先水平，同意通过结项验收。'
            ],
            images: ''
          },
          {
            id: 15,
            title: '公司参与项目顺利通过省水利厅结项验收',
            time: '2021-11-09 17:03:00',
            text: [
              '近日，公司参与的河南省水利科技攻关项目“多目标决策及大数据预警在混凝土温控施工的研究与应用”顺利通过河南省水利厅结项验收。',
              '该项目以河南省水利第二工程局、郑州大学、河南郑大水利科技有限公司为主要完成单位，通过引入多目标决策的综合评价体系，实现了对温控方案的科学确定，结合大数据预测预警技术，开发形成大数据支撑下的混凝土温控智能平台，实现了混凝土温度的准确预测与动态调整，上述研究成果在河南省多个项目中得到成功应用，取得了一定的经济效益和社会效益。',
              '专家组在听取项目汇报后，审查了项目相关资料，在详细质询的基础上，认为项目研究达到了预期目标，研究成果具有国内领先水平，同意通过结项验收。'
            ],
            images: ''
          },
          {
            id: 16,
            title: '公司多项专利获国家授权',
            time: '2021-04-23 16:19:00',
            text: [
              '近日，公司多项专利获国家知识产权局授权。',
              '据悉，公司围绕水电站优化运行的相关核心技术，积极申报国家专利，先后申请国家实用新型专利、发明专利30余项，近日，多项专利获国家知识产权局授权。后续，公司将继续申请产权保护，并积极推进已授权专利的转化应用。'
            ],
            images: ''
          },
          {
            id: 17,
            title: '公司应邀参加“厚山论道”活动',
            time: '2020-11-20 16:21:00',
            text: [
              '近日，公司应邀参加郑州大学大学科技园和科技金融广场主办的“厚山论道” 活动，包括国投资管在内的多家单位参与。',
              '活动中，公司负责人王朋介绍了公司概况，就中小型水电站优化运行成套技术及系统等核心技术进行了讲解，并就该技术的研究现状、应用前景等问题与现场人员进行了互动交流。目前，以公司主创人员多年系统科学研发形成的中小型水电站优化运行成套技术及系统，已经拥有完全知识产权，先后获得河南省科技进步奖等多个奖项，并成功应用于省内外多个电站，取得了较好的实施和应用效果。'
            ],
            images: require('@/assets/images/news/微信图片_20201120161544.jpg')
          },
          {
            id: 18,
            title: '郑大水利科技赴信阳开展电站服务工作',
            time: '2020-11-20 16:12:00',
            text: [
              '近日，郑大水利科技公司一行5人赴信阳开展电站现场服务工作。',
              '公司一行先后到信阳市鲇鱼山水库水电站、新集子水电站、迎水寺水电站开展调研，就电站遇到的实际问题与电站技术人员进行了深入交流，并结合优化运行技术，在现场开展服务工作，取得了较好的应用效果。 ',
              '通过此次电站现场服务工作，验证了优化运行技术在现场的应用效果，为下一步工作推广提供了基础。'
            ],
            images: require('@/assets/images/news/微信图片_20201120161139.jpg')
          },
          {
            id: 19,
            title: '郑大水利科技赴洛阳考察学习',
            time: '2020-07-09 17:05:00',
            text: [
              '7月7日，郑大水利科技一行5人赴洛阳考察学习。',
              '考察组一行先后考察参观了洛阳市宜阳县锦山水电站、辉煌水电站，在电站工作人员的带领下，详细参观了电站的相关设备，并深入了解电站运行现状及存在的问题；随后，考察组一行还结合现场情况进行了优化运行试验。',
              '通过此次考察学习，加强了公司对电站实际运行情况的了解，为公司下阶段的工作开展提供了技术支撑。'
            ],
            images: ''
          },
          {
            id: 20,
            title: '郑大水利科技参加园区年度工作会议',
            time: '2020-07-01 18:04:00',
            text: [
              '6月23日，郑大水利科技参加郑州大学科技园2020年度工作会议暨专家报告会。',
              '会议对郑州大学科技园2019年的工作进行了总结，对优秀企业进行了表彰，对2020年的工作进行了部署安排，并邀请专家作《时代变革与科创中国》主题报告。',
              '会上，河南郑大水利科技有限公司荣获郑州大学科技园2019年度知识产权奖励。通过此次会议，公司明确了进一步的发展方向，为公司下一阶段的工作指明了方向。'
            ],
            images: ''
          },
          {
            id: 21,
            title: '郑大水利科技通过国家科技型中小企业备案',
            time: '2020-07-01 15:42:00',
            text: [
              '近日，河南省2020年第八批入库科技型中小企业名单公告，河南郑大水利科技有限公司顺利通过。',
              '国家科技型中小企业备案是对企业创新、科研活动的重要支持和鼓励。此次入选，是对公司前期科研工作的肯定，同时也激发了公司科研成果转换的动力。'
            ],
            images: ''
          },
          {
            id: 22,
            title: '郑大水利科技通过郑州市科技型企业备案',
            time: '2020-07-01 14:31:00',
            text: [
              '近日，2020年度第一批拟入库郑州市科技型企业名单公示，河南郑大水利科技有限公司顺利通过。',
              '公司前期致力于科研成果转换，积极申请知识产权保护和市场推广应用。下一步，公司将以此为契机，继续加大科研投入。'
            ],
            images: ''
          },
          {
            id: 23,
            title: '郑大水利科技多项科技成果获国家授权登记',
            time: '2020-06-10 20:40:00',
            text: [
              '近日，郑大水利科技多项科技成果获国家授权登记。',
              '据悉，公司创建以来，高度重视科技创新和知识产权保护，共提交国家知识产权申请30余项，包括软件著作权、实用新型专利和发明专利等。',
              '近日，包括“陆浑水库水电站优化调度系统V1.0”、“陆浑水库水电站厂内经济运行管理系统V1.0”、“一种生态流量的监控固定装置”、“一种生态流量监控设备的移动固定装置”获得国家授权登记。',
              '下阶段，公司将围绕“水电站优化运行技术”继续开展科技研究，并积极进行知识产权保护以及成果的应用转化。'
            ],
            images: ''
          }
        ],
        //测试数据
        newsData1: [
          {
            id: 4,
            title: '公司获批郑州市工程技术中心',
            time: '2023-07-07 17:46:00',
            text: [
              '近日，郑州市发展改革委员会公布了2022年新建郑州市工程研究中心名单，公司顺利获批郑州市工程技术中心。',
              '郑州市工程技术研究中心是依托市内某一行业或领域内具有较高水平的企业组建的研发中心，其任务是针对行业发展中的重大关键、共性技术问题，开展研发和成果的工程化、产业化，推动相关行业、领域的技术进步和产业发展。',
              '此次获批的“郑州市水利水电智能装备工程研究中心”为公司联合河南省水利与环境职业学院共同申报，旨在解决水利水电智能装备系统的研发关键技术问题，推动水利水电装备智能化升级发展。'
            ],
            images: ''
          }
        ],

        imageList: [
          // {
          //   id: 1,
          //   src: require('@/assets/images/pro/焦作市广利灌区水电站设计.png')
          // },
          // {
          //   id: 2,
          //   src: require('@/assets/images/pro/栗子坪水电站优化运行项目.png')
          // },
          {
            id: 3,
            src: require('@/assets/images/pro/陆浑水库水电站优化调度项目.png')
          },
          {
            id: 4,
            src: require('@/assets/images/pro/陆浑水库水电站增效扩容改造项目.png')
          },
          {
            id: 5,
            src: require('@/assets/images/pro/陆浑水资源优化配置研究—科技攻关项目.png')
          },
          {
            id: 6,
            src: require('@/assets/images/pro/洛宁梯级水电站优化调度项目.png')
          },
          {
            id: 7,
            src: require('@/assets/images/pro/南湾水库水电站增效扩容改造项目.png')
          },
          {
            id: 8,
            src: require('@/assets/images/pro/鲇鱼山梯级水电站优化调度项目.png')
          },
          {
            id: 9,
            src: require('@/assets/images/pro/鲇鱼山梯级水电站远程故障诊断项目.png')
          }
        ],

        isShowNewsUi: false, //新闻界面是否显示

        selectedItem: null, // 存储点击的项
        gsjjText:
          '河南郑大水利科技有限公司，成立于2019年4月15日，位于河南省郑州市高新技术开发区郑州大学大学科技园2号楼，是一家依托于高校师资力量和科研平台，以软件开发、科研成果转化、技术咨询与服务为主营业务的公司。现有专兼职人员10余名，硕士及以上学历占比90%以上，中高级职称占比80%以上。'
      }
    },
    methods: {
      handleMoreClick() {
        console.log("点击了 '更多'")
        // 这里可以写你的逻辑，比如跳转页面
        this.$router.push('/myCases')
      },
      handleMoreClickXQ() {
        console.log("点击了 '详情'")
        // 这里可以写你的逻辑，比如跳转页面
        this.$router.push('/about')
      },
      // 处理子组件传递的数据
      handleItemClick(item) {
        this.isShowNewsUi = !this.isShowNewsUi

        this.selectedItem = item
        console.log('父组件接收到点击项：', item)
        // 使用filter方法筛选出标题匹配的新闻项
        this.newsData1 = this.newsData.filter((item) => item.title === this.selectedItem.text)
        console.log('点击赋值后的数组：', this.newsData1)
      },
      handleReturnFromNews() {
        // 这里实现返回逻辑
        console.log('收到来自子组件的返回事件')
        this.isShowNewsUi = !this.isShowNewsUi
        // 如果是使用vue-router，可以这样返回上一页：
        // this.$router.go(-1);

        // 或者执行其他自定义返回逻辑
        // this.someReturnMethod();
      }
    }
  }
</script>

<style scoped>
  .home {
    width: 100%;
    /* height: 800px; */
    /* background-color: pink; */
  }
  .home-new {
    width: 100%;
    /* height: 600px; */
  }
  .home-top {
    width: 100%;
    height: 285px;
    /* background-color: aqua; */
    display: flex;
    justify-content: space-between; /* 左右两端对齐 */
    align-items: center; /* 垂直居中（可选） */
  }
  .top-left {
    width: 47%;
    height: 95%;
    margin: 10px;
    padding: 0 10px;
    /* background-color: rgb(196, 231, 172); */
  }
  .top-left > h3 {
    text-align: center;
    border-bottom: 1px solid #fff;
  }
  .top-left > p {
    padding-top: 1em;
    text-indent: 2em;
    display: -webkit-box;
    -webkit-line-clamp: 5; /* 限制行数 */
    -webkit-box-orient: vertical;
    overflow: hidden;
    width: 100%;
    line-height: 2.2em;
  }
  .top-right {
    width: 47%;
    height: 95%;
    margin: 10px;
    padding: 0 10px;
    /* background-color: rgb(196, 231, 172); */
  }
  .top-right > h3 {
    text-align: center;
    border-bottom: 1px solid #fff;
  }
  .new-lists {
    width: 100%;
    height: 80%;
    /* background-color: aqua; */
  }

  .home-bottom {
    width: 98%;
    height: 300px;
    padding: 10px;

    /* background-color: aqua; */
  }
  .bottom-title {
    border-bottom: 1px solid #fff;
    display: flex;
    justify-content: space-between; /* 这将使元素分布在两端 */
    align-items: center; /* 垂直居中 */
  }
  .bottom-title > h3 {
    text-align: center;
  }

  .bottom-title span {
    margin-left: auto; /* "更多" 靠右 */
    /* padding-left: 10px; */
    font-size: 12px;
    color: #66b1ff;
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
    text-align: center;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: rgba(255, 255, 255, 0.01);
    /* background: transparent; */
  }

  .el-carousel__item:nth-child(2n + 1) {
    background-color: rgba(255, 255, 255, 0.01);
    /* background: transparent; */
  }
</style>
>
